/*
 * @Author: ningbo.kang
 * @Date: 2020-03-31 17:51:12
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-07-06 11:13:48
 * @Description: 描述
 */

/**
 *
 * undefined: 数据字段不会发送给服务器端
 * null: 数据字段会发送给服务器端，将表字段设置为默认值，比如 日期date,datetime类型
 * "": 会将空字符串发送给服务器端，使用空替换表字段
 */

export default {
  blank: {
    default: '',
  },
  cascader: {
    defaultValue: '',
  },
  checkbox: {
    defaultValue: '',
  },
  date: {
    defaultValue: null,
  },
  dateRange: {
    defaultValue: [false, false],
  },
  fileupload: {
    // 空数组字符串
    defaultValue: '[]',
  },
  hidden: {
    defaultValue: undefined,
  },
  html: {
    defaultValue: '',
  },
  link: {
    defaultValue: '[]',
  },
  input: {
    defaultValue: '',
  },
  number: {
    defaultValue: null,
  },
  radio: {
    defaultValue: '',
  },
  rate: {
    defaultValue: 0,
  },
  select: {
    defaultValue: '',
    multiple: {
      defaultValue: [],
    },
  },
  slider: {
    defaultValue: 0,
  },
  switch: {
    defaultValue: false,
  },
  table: {
    defaultValue: [],
  },
  text: {
    default: '',
  },
  time: {
    defaultValue: null,
  },
  treeSelect: {
    defaultValue: '',
  },
  textarea: {
    defaultValue: '',
  },
  // 布局类，无实际意义
  card: {
    defaultValue: undefined,
  },
  grid: {
    defaultValue: undefined,
  },
  tabs: {
    defaultValue: undefined,
  },
  divider: {
    defaultValue: undefined,
  },
  dialog: {
    defaultValue: null,
  },
  processSelect: {
    defaultValue: undefined,
  },
  compute: {
    defaultValue: undefined,
  },
};
